var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header',{ref:"header",on:{"refreshHome":_vm.refreshHome,"refreshHomePeriod":_vm.refreshHomePeriod,"refreshHomeYear":_vm.refreshHomeYear,"showSelectedYear":_vm.showSelectedYear}}),_c('router-view',{ref:"childComponent"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }